import React from "react";

export default function Figma() {
  return (
    <a href="https://www.figma.com/file/H3xQWJt6P4XJ5MUZzfOyvO/NOISE-Final?node-id=0%3A1" target="_blank">
      <svg
        className="icon"
        width="36"
        height="53"
        viewBox="0 0 36 53"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.83765 53C13.716 53 17.6753 49.0426 17.6753 44.1666V35.3333H8.83765C3.95927 35.3333 0 39.2906 0 44.1666C0 49.0426 3.95927 53 8.83765 53Z"
          fill="#0ACF83"
        />
        <path
          d="M0 26.5C0 21.624 3.95927 17.6667 8.83765 17.6667H17.6753V35.3334H8.83765C3.95927 35.3334 0 31.376 0 26.5Z"
          fill="#A259FF"
        />
        <path
          d="M0 8.83333C0 3.95733 3.95927 0 8.83765 0H17.6753V17.6667H8.83765C3.95927 17.6667 0 13.7093 0 8.83333Z"
          fill="#F24E1E"
        />
        <path
          d="M17.6753 0H26.5129C31.3913 0 35.3506 3.95733 35.3506 8.83333C35.3506 13.7093 31.3913 17.6667 26.5129 17.6667H17.6753V0Z"
          fill="#FF7262"
        />
        <path
          d="M35.3506 26.5C35.3506 31.376 31.3913 35.3334 26.5129 35.3334C21.6346 35.3334 17.6753 31.376 17.6753 26.5C17.6753 21.624 21.6346 17.6667 26.5129 17.6667C31.3913 17.6667 35.3506 21.624 35.3506 26.5Z"
          fill="#1ABCFE"
        />
      </svg>
    </a>
  );
}
